import React from 'react'
import Button from '@Components/Buttons/Button'

interface ConfirmationStepProps {
    closeSidebar: () => void
}

const ConfirmationStep = (props: ConfirmationStepProps) => {
    const { closeSidebar } = props

    return (
        <>
            <h2>Thank you for submitting your request</h2>
            <p>We'll review your request and follow-up with any updates.</p>
            <p>
                All notifications will be sent to your email. We'll let you know if your suggested change is accepted.
            </p>
            <Button mainColor type="primary" onClick={closeSidebar}>
                Done
            </Button>
        </>
    )
}
export default ConfirmationStep
